/**
 * Patron / shared surface: `api` (token: 'token', then OAuth session token).
 * Endpoints called today by the public pages, AuthContext and the site chrome.
 */
import { createClient, qs } from './client';

export const api = createClient('patron');

// Auth
export const getMe = (config) => api.get('/auth/me', config);
export const signup = (payload, config) => api.post('/auth/signup', payload, config);
export const login = (payload, config) => api.post('/auth/login', payload, config);
export const updateProfile = (payload, config) => api.put('/auth/profile', payload, config);
export const googleAuth = (payload, config) => api.post('/auth/google', payload, config);
export const processOAuthSession = (payload, config) => api.post('/auth/oauth/process-session', payload, config);
export const forgotPassword = (payload, config) => api.post('/auth/forgot-password', payload, config);
export const resetPassword = (payload, config) => api.post('/auth/reset-password', payload, config);
export const verifyEmail = (payload, config) => api.post('/auth/verify-email', payload, config);
export const resendVerification = (payload = {}, config) => api.post('/auth/resend-verification', payload, config);

// Deals & claims
export const getMyClaims = (config) => api.get('/deals/my-claims', config);
export const claimDeal = (payload, config) => api.post('/deals/claim', payload, config);
export const checkDeal = (dealId, config) => api.get(`/deals/check/${dealId}`, config);

// Businesses (public)
export const listBusinesses = (config) => api.get('/businesses', config);
export const getBusinessBySlug = (slug, config) => api.get(`/businesses/${slug}`, config);

// Hubs, scan, locations
export const getHubsWithDeals = (config) => api.get('/hubs/with-deals', config);
export const getNearestHub = (params, config = {}) => api.get('/hubs/nearest', { ...config, params });
export const getHubCoaster = (hubId, config) => api.get(`/hubs/${hubId}/coaster`, config);
export const unlockHub = (hubId, payload = {}, config) => api.post(`/hubs/unlock/${hubId}`, payload, config);
export const getLocationFeaturedDeal = (locationId, config) => api.get(`/locations/${locationId}/featured-deal`, config);
// recordScan (POST /scan/record) moved to ./public in Phase 6c (it gained the design token
// `d`); the lib/api barrel still exports it.
export const discoverScan = (params = {}, config) => api.get(`/scan/discover${qs(params)}`, config);

// Taps (REWARDS flag)
export const getTapsBalance = (config) => api.get('/taps/balance', config);

// Forms & email preferences
export const submitContactForm = (payload, config) => api.post('/forms/contact', payload, config);
export const getEmailPreferences = (token, config) => api.get(`/email-preferences/${token}`, config);
export const updateEmailPreferences = (token, payload, config) => api.put(`/email-preferences/${token}`, payload, config);
